import {_, pluralize, React, observer, useAsync, Fragment} from '@api'
import {CatalogDataItem_Mapped, useStores, LoadingIndicator, BuilderCard} from '@modules'
import {LibraryItemConfig} from '@stores'
import {ListPreviewCard} from 'centric-ui-components'
import * as css from './AssignUnique.css'
import { Icon } from '@blueprintjs/core'
interface MyProps {
  library: LibraryItemConfig
  newValue: any
  catalogItem: any
  alreadyAssignedTo: Array<any>
  currentAssignedValue?: any
}
export const ReassignLibraryItemDialogContent = observer(function ReassignLibraryItemDialogContent({library, newValue, catalogItem, alreadyAssignedTo, currentAssignedValue}: MyProps) {
  const stores = useStores(),
    {strings, catalog} = stores,
    { loading: loadingToLibraryItem, value: toLibraryItem } = useAsync(async () => {
    if (library && currentAssignedValue) {
      return await catalog.getLibraryItem({index: library.index, id: currentAssignedValue.id})
    }

    return null
  })

  const {loading: loadingNewLibraryItem, value: newLibraryItem} = useAsync(async () => {
    if (library) {
      return await catalog.getLibraryItem({index: library.index, id: newValue.id})
    }

    return null
  })

  const colorwayCard = <CatalogDataItem_Mapped data={currentAssignedValue ? toLibraryItem : newLibraryItem} dataMap={catalog.dataMapForLibrary(library)}>
    <ListPreviewCard
      stores={stores}
      showImage
      avatar={_.toUpper(library.label ? library.label[0] : '?')}
      library={library}
      hideTooltips
      showTooltip={false}
      showHex/>
  </CatalogDataItem_Mapped>

  //console.log({catalogItem, alreadyAssignedTo, currentAssignedValue, from: fromLibraryItem, to: toLibraryItem})
  return (
    <div className={css.root}>
      {alreadyAssignedTo.length > 0 // Library item has already been assigned to another catalog item
       ? <div className={css.alreadyAssigned}>
         <label className={css.title}>{library.label ?? library.name} {strings.hasAlreadyBeenAssigned}</label>
         <div className={css.libraryItem}>
           {colorwayCard}
         </div>
         <label className={css.title}>Existing</label>
         <div className={css.alreadyAssignedCatalogItems}>
           {alreadyAssignedTo.map((itemData, i) => <BuilderCard levelOfDetail={1} data={itemData} key={i} hideButtons disableSelection/>)}
         </div>
       </div>
      :currentAssignedValue ?
      <div className={css.reassign}>
        <label>{strings.overwriteExisting} {library.label}?</label>
        {loadingNewLibraryItem ? <LoadingIndicator/> :
         <CatalogDataItem_Mapped data={newLibraryItem} dataMap={catalog.dataMapForLibrary(library)}>
          <ListPreviewCard
            showImage stores={stores}
            avatar={_.toUpper(library.label ? library.label[0] : '?')}
            library={library}
            cardDetails={library?.cardUI}
            hideTooltips
            showTooltip={false}
            showHex/>
        </CatalogDataItem_Mapped>}
        <Icon icon='arrow-down' />
        {loadingToLibraryItem ? <LoadingIndicator /> : colorwayCard}
        {false && alreadyAssignedTo.length > 0 && <div>
	        <label>{library.label} is already assigned to {alreadyAssignedTo.length} {_.toLower(pluralize(catalog.catalogItemName, alreadyAssignedTo.length))}:</label>
	        <div className={css.alreadyAssignedCatalogItems}>
                {alreadyAssignedTo.map((itemData, i) => <BuilderCard levelOfDetail={1} data={itemData} key={i} hideButtons disableSelection/>)}
          </div>
        </div>}
      </div>
      : <div className={css.overwrite}>
         {alreadyAssignedTo.length > 0 ?
          <Fragment>
          <label>Reassign {_.toLower(library.label)}?</label>

         <div className={css.alreadyAssignedCatalogItems}>
           {alreadyAssignedTo.map((itemData, i) => <BuilderCard levelOfDetail={1} data={itemData} key={i} hideButtons disableSelection />)}
           <Icon icon='arrow-right'/>
           <BuilderCard levelOfDetail={1} data={catalogItem} hideButtons disableSelection/>
         </div>

            {colorwayCard}
          </Fragment>
          :<Fragment>
            <div>???</div>
           </Fragment>}
         {/*<label>Reassign the {library.label} to this {_.toLower(catalog.catalogItemName)} instead?</label>*/}
         {/*<div className={css.assignTo}>*/}
         {/*  <CatalogDataItem_Mapped data={toLibraryItem} dataMap={library.dataMap}>*/}
         {/*    <ListPreviewCard*/}
         {/*      showImage*/}
         {/*      avatar={_.toUpper(library.label ? library.label[0] : '?')}*/}
         {/*      library={library}*/}
         {/*      cardDetails={library?.cardUI}*/}
         {/*      hideTooltips*/}
         {/*      showTooltip={false}*/}
         {/*      showHex/>*/}
         {/*  </CatalogDataItem_Mapped>*/}
         {/*  <Icon icon='arrow-right'/>*/}
         {/*  <BuilderCard levelOfDetail={1} data={catalogItem} hideButtons />*/}
         {/*</div>*/}
       </div>}
    </div>
  )
})



// WEBPACK FOOTER //
// ./src/stores/catalog/AssignUniqueLibraryItem/AssignUnique.tsx